export enum CRStatus {
  DRAFT = 'DRAFT',
  GENERATING_MATCHES = 'GENERATING_MATCHES',
  PROVIDERS_PRESENTED = 'PROVIDERS_PRESENTED',
  INTRODUCTIONS = 'INTRODUCTIONS',
  NEGOTIATIONS = 'NEGOTIATIONS',
  DEAL_WON = 'DEAL_WON',
  DEAL_LOST = 'DEAL_LOST',
}
